<template>
    <div>
        <Breadcrumbs main="Vendor"  title="Purchase Orders"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
                
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
            
                            <div class="table-responsive datatable-vue">
                                <b-table
                                    show-empty
                                    stacked="md"
                                    :items="items"
                                    :fields="tablefields"
                                    :filter="filter"
                                    :current-page="currentPage"
                                    :per-page="perPage"
                                    @filtered="onFiltered"
                                >
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(purchase_order_id)="data">
                                        <span>
                                            <router-link :to="`/procurement/purchase-order/${data.item.id}`" class="link-style">
                                                {{ data.item.purchase_order_id }}
                                            </router-link>
                                        </span>
                                    </template>
                                    <template #cell(subtotal)="data">
                                        <span>
                                            {{ data.item.subtotal }} {{ data.item.currency }}
                                        </span>
                                    </template>
                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 0.5rem;" v-if="data.item.vendor_status === 'PENDING'">
                                            <b-button variant="outline-secondary" size="sm" @click="acceptPO(data.item.id)" v-b-modal.modal-center-accept>Accept</b-button>
                                            <b-button variant="outline-danger" size="sm" @click="rejectPO(data.item.id)" v-b-modal.modal-center-reject>Reject</b-button>
                                        </span>
                                        <span style="display: flex; gap: 0.5rem;" v-else-if="data.item.vendor_status === 'ACCEPTED'">
                                            <b-button variant="success" size="sm" disabled>Accepted</b-button>
                                        </span>
                                        <span style="display: flex; gap: 0.5rem;" v-else-if="data.item.vendor_status === 'REJECTED'">
                                            <b-button variant="danger" size="sm" disabled>Rejected</b-button>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
            
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    class="my-0"
                                ></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->

        <!-- Accept Modal -->
        <b-modal 
            id="modal-center-accept" 
            centered 
            hide-header
            @ok="handleAcceptOk"
        >
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to accept this purchase order?</div>
        </b-modal>
        
        <!-- Reject Modal -->
        <b-modal 
            id="modal-center-reject" 
            centered 
            hide-header
            @ok="handleRejectOk"
        >
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to reject this purchase order?</div>
            <textarea v-model="vendor_rejection_reason" class="form-control" rows="3" placeholder="Enter rejection reason..."></textarea>
        </b-modal>
    </div>
</template>
  
<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    data() {
        return {
            tablefields: [
                { key: 'index', label: '#' },
                { key: 'purchase_order_id', label: 'Purchase Order ID', sortable: true },
                { key: 'email', label: 'Email', sortable: true },
                { key: 'purchase_order_date', label: 'Purchase Order Date', sortable: true },
                { key: 'due_date', label: 'Due Date', sortable: true },
                { key: 'subtotal', label: 'Grand Total', sortable: true },
                { key: 'action', label: 'Action', sortable: false }
            ],
            initialLoad: true,
            filter: null,
            vendor_rejection_reason: '',
            selectedPO: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100]
        };
    },

    computed: { 
        ...mapState({
            items: state => state.vendor.purchase_order_list,
            count: state => state.vendor.purchase_order_list_count
        })
    },

    mounted() {
         if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {

                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitial();
            } else {

                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);

                this.fetchInitial();
            }
        }
    },

     watch: {
        items(newValue) {
            this.totalRows = this.count;
        },

        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/vendor/purchase_order',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("vendor/fetchVendorPurchaseOrder", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/vendor/purchase_order',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("vendor/fetchVendorPurchaseOrder", {
                    perPage: newperPage,
                    currentPage: this.currentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        }
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        fetchInitial() {
            this.$store.dispatch("vendor/fetchVendorPurchaseOrder", {
                perPage: this.perPage,
                currentPage: this.currentPage,
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        acceptPO(item) {
            this.selectedPO = item;
        },

        rejectPO(item) {
            this.selectedPO = item;
        },

        handleAcceptOk() {
            this.$store.dispatch("vendor/acceptPurchaseOrder", {
                id: this.selectedPO,
                page: this.currentPage,
                perPage: this.perPage
            }).then((response) => {
                if (response.code === 200) {
                    Swal.fire('Success', 'Purchase order accepted successfully.', 'success');
                } else {
                    Swal.fire('Error', 'Failed to accept purchase order.', 'error');
                }
                this.selectedPO = null;
            })
        },

        handleRejectOk() {
            this.$store.dispatch("vendor/rejectPurchaseOrder", {
                id: this.selectedPO,
                vendor_rejection_reason: this.vendor_rejection_reason,
                page: this.currentPage,
                perPage: this.perPage
            }).then((response) => {
                    if (response.code === 200) {
                        Swal.fire('Success', 'Purchase order rejected successfully.', 'success');
                    } else {
                        Swal.fire('Error', 'Failed to reject purchase order.', 'error');
                    }
                    this.selectedPO = null;
                    this.vendor_rejection_reason = '';
                })
        }
    }
};
</script>
  